
import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/MediaStudios.css';

const MediaStudios = () => {
  return (
    <>
      <Helmet>
        <title>Redbox Global Media Studios | Original Journalism & Market Stories</title>
        <meta
          name="description"
          content="Redbox Global Media Studios produces original journalism, documentaries, interviews, and market-driven stories that shape global business conversations."
        />
        <meta
          name="keywords"
          content="Redbox Global Media Studios, original journalism, business media, financial documentaries, market storytelling, global business news"
        />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/media-studios" />
        <meta
          property="og:title"
          content="Redbox Global Media Studios | Original Journalism & Market Stories"
        />
        <meta
          property="og:description"
          content="Original reporting, interviews, and documentaries from Redbox Global Media Studios."
        />
        <meta
          property="og:image"
          content="https://images.unsplash.com/photo-1492724441997-5dc865305da7?w=1200&h=630&fit=crop"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Redbox Global Media Studios | Original Journalism"
        />
        <meta
          name="twitter:description"
          content="Original reporting, interviews, and documentaries from Redbox Global Media Studios."
        />
        <meta
          name="twitter:image"
          content="https://images.unsplash.com/photo-1492724441997-5dc865305da7?w=1200&h=630&fit=crop"
        />

        <link
          rel="canonical"
          href="https://redboxglobal.com/media-studios"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
      </Helmet>

      <div className="page-container">
        <div className="page-header">
          <h1>Redbox Global Media Studios</h1>
          <p className="page-subtitle">
            Original journalism, interviews, and market-driven storytelling
          </p>
        </div>

        <div className="page-content">
          {/* Featured Article */}
          <a
            href="/article/inside-redbox-global-media-studios"
            style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
          >
            <div className="featured-article">
              <div className="featured-image">
                <img
                  src="https://images.unsplash.com/photo-1492724441997-5dc865305da7?w=1200&h=600&fit=crop"
                  alt="Redbox Global Media Studios production"
                />
              </div>
              <div className="featured-content">
               
                <h2>Inside Redbox Global Media Studios</h2>
                <p>
                  Go behind the scenes of Redbox Global Media Studios and explore
                  how our editorial teams produce original journalism, exclusive
                  interviews, documentaries, and market-moving stories watched
                  by a global audience.
                </p>
                <span className="article-meta">
                  Editorial Feature • Updated 2026
                </span>
              </div>
            </div>
          </a>

          {/* Article Grid */}
          <div className="content-grid">
            <a
              href="/article/original-documentaries"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?w=600&h=400&fit=crop"
                    alt="Business documentary production"
                  />
                </div>
                <div className="article-content">
                 
                  <h2>Original Business Documentaries</h2>
                  <p>
                    In-depth documentaries exploring the forces shaping global
                    markets, industries, and economies.
                  </p>
                  <span className="article-meta">On Demand</span>
                </div>
              </article>
            </a>

            <a
              href="/article/executive-interviews"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1551836022-deb4988cc6c0?w=600&h=400&fit=crop"
                    alt="Executive interview studio"
                  />
                </div>
                <div className="article-content">
                  
                  <h2>Exclusive Executive Interviews</h2>
                  <p>
                    Conversations with CEOs, investors, policymakers, and
                    innovators shaping the future of business.
                  </p>
                  <span className="article-meta">Weekly Series</span>
                </div>
              </article>
            </a>

            <a
              href="/article/global-market-stories"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=600&h=400&fit=crop"
                    alt="Global market reporting"
                  />
                </div>
                <div className="article-content">
                  
                  <h2>Global Market Stories That Matter</h2>
                  <p>
                    Timely, data-driven stories explaining market moves and
                    economic shifts around the world.
                  </p>
                  <span className="article-meta">Daily Coverage</span>
                </div>
              </article>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default MediaStudios;
